import {Component, OnInit} from '@angular/core';
import {LoginComponent} from '../../shared/auth/login/login.component';
import {LoginService} from '../../shared/auth/login/login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../shared/auth/auth.service';
import {Principal} from '../../shared/auth/principal.service';
import {SnackBarService} from '../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../shared/components/loader-service/global-spinner.service';

@Component({
  selector: 'cm-publisher-login',
  templateUrl: '../../shared/auth/login/login.component.html',
  styleUrls: ['../../shared/auth/login/login.component.scss']
})
export class PublisherLoginComponent extends LoginComponent implements OnInit {
  registerLinkVisible = true;
  termsAndConditions = true;


  constructor(loginService: LoginService, router: Router, route: ActivatedRoute, authService: AuthService, principal: Principal, snackBarService: SnackBarService, globalSpinnerService: GlobalSpinnerService) {
    super(loginService, router, route, authService, principal, snackBarService, globalSpinnerService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
